$.fn.isOnScreen = function(){

    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    if(win.width() > 767){
    	viewport.bottom = viewport.top + win.height() - 110;
    } else {
    	viewport.bottom = viewport.top + win.height() - 55;
    }

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight() ;

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};

$(window).on('load', function()
{
	var wn = window.navigator,
		ua = wn.userAgent.toLowerCase(),
		av = wn.appVersion.toLowerCase(),
		up = window.location.protocol.toLowerCase();
	
	var	isMobile = (/iphone|ipod|kindle|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(ua)),
		isTablet = (/ipad|sch-i800|playbook|xoom|tablet|gt-p1000|gt-p7510|sgh-t849|nexus 7|shw-m180s|a100|dell streak|silk/i.test(ua)),
		isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

	$.easing.quart         = function (x, t, b, c, d) { return -c * ((t=t/d-1)*t*t*t - 1) + b; };
	$.easing.easeOutCubic  = function (x, t, b, c, d) { t /= d; t--; return c*(t*t*t + 1) + b; };
	$.easing.easeInOutQuad = function (x, t, b, c, d) { t /= d/2; if (t < 1) return c/2*t*t + b; t--; return -c/2 * (t*(t-2) - 1) + b; };
	$.easing.easeInQuad    = function (x, t, b, c, d) { t /= d; return c*t*t + b; };
	$.easing.easeOutQuad   = function (x, t, b, c, d) { t /= d; return -c * t*(t-2) + b; };

	var $window = $(window);
	var $page = $('body').attr('id');
	var _ww,_wh, _ws;
	
	
	

	var navOp = false;
	$('#corner-bottom-left').on({ click:function($evt) { _setNav(); }});
	$('#nav-tel').on({ click:function($evt) { window.location.href = 'tel:008111-522-9850'; }});
	
	$('a').click(function($evt) {
		var uri = $(this).attr('href');
		if($(this).attr('target') == '_blank'){
			window.open(uri);
		} else {
			if(navOp) { _setNav(); }
			$('aside#loader').css({'display':'block'}).animate({ 'opacity': 1 }, 500, 'easeOutQuad', function() { 
				window.location.href = uri;
			});
		}
	    $evt.preventDefault();
	});


  	var checkbottomleftcolor = false;
	function _setNav() {
		if(!navOp){
			$('nav').stop(true,false).animate({ 'left': 0 }, 800, 'quart');
			$('#corner-bottom-left-stat-scroll').stop(true,false).animate({ 'left': '38px' }, 500, 'quart');
			if(!$('#corner-bottom-left').hasClass('black')) { 
				$('#corner-bottom-left').addClass('black'); 
				checkbottomleftcolor = true;
			}
			navOp = true;
		} else {
			if(_ww > 767){
				$('nav').stop(true,false).animate({ 'left': '-33.33333%' }, 800, 'quart');
			} else {
				$('nav').stop(true,false).animate({ 'left': '-100%' }, 800, 'quart');
			}
			$('#corner-bottom-left-stat-scroll').stop(true,false).animate({ 'left': '18px' }, 800, 'quart');
			if(checkbottomleftcolor){
				$('#corner-bottom-left').removeClass('black'); 
				checkbottomleftcolor = false;
			}
			navOp = false;
			__setScroll();
		}
		 
	}



	$('#footer-scrolltop').on({ 
		click:function($evt) { 
			$('html, body').animate({scrollTop: 0}, 1200, 'easeInOutQuad');
			$evt.preventDefault();
		}
	});

	if($page === 'teaser')
	{
        if(isMobile || isTablet)
        {
	        window.location.href = './top/index.html';
        }
        else 
        {
        	/*if(isTablet) {
        		var video = document.querySelector('video');
	            video.src = '';
	            video.src = 'media/intro-sp.mp4';
        	}*/

        	$('aside#loader img').delay(100).animate({ 'opacity': 1 }, 1000, 'easeInOutQuad', function(){ });
    		$('aside#loader').delay(1100).animate({ 'opacity': 0 }, 1000, 'easeInOutQuad', function(){
	            $(this).css({'display':'none'}).removeClass('black');
	            $('aside#loader img').css({'opacity':0});
	        });

	        $('video').on({ 
	            click:function($evt) { 
	                $('aside#loader').css({'display':'block'}).animate({ 'opacity': 1 }, 1000, 'easeInOutQuad', function(){
	                	window.location.href = './top/index.html';
	                }); 
	            }
	        });

	        setTimeout(function(){
	        	$('video')[0].currentTime = 0;
		        $('video')[0].play();
		        $('video')[0].addEventListener('ended', function(){ 
		            $('aside#loader').css({'display':'block'}).animate({ 'opacity': 1 }, 1000, 'easeInOutQuad', function(){
		            	window.location.href = './top/index.html';
		            });    
		        }, false);

	        }, 1200);

	      
        }
      
	}
	else
	{
		if($page != 'main') {
			$('aside#loader').delay(400).animate({opacity: 0 }, 1200, 'easeInOutQuad',function(){
				$(this).css({'display':'none'});
				$('aside#loader img').css({'opacity': 0});
			});
		}
	}

	//=======================

	if($page === 'main')
	{
		if(isMobile){
			var refername = ['about','rooms','restaurant','graphic-design','gallery','privacy'],
				referurl = document.referrer,
				refercache = false;
			for(var i=0; i<refername.length; i++){
				if(referurl.includes(refername[i])){
					refercache = true;
				} 
			}

			if(!refercache) { 
				$('aside#loader img').delay(100).animate({opacity: 1 }, 800, 'easeInOutQuad',function(){
					$(this).delay(800).animate({opacity: 0 }, 500, 'easeInOutQuad');
				});
				$('aside#loader').stop(true,true).delay(1800).animate({opacity: 0 }, 1200, 'easeInOutQuad',function(){
					$(this).css({'display':'none'});
					$('aside#loader img').css({'opacity': 0});
				});
			}
			else 
			{
				$('aside#loader').delay(400).animate({opacity: 0 }, 1200, 'easeInOutQuad',function(){
					$(this).css({'display':'none'});
					$('aside#loader img').css({'opacity': 0});
				});
			}
		}
		else 
		{
			$('aside#loader').delay(400).animate({opacity: 0 }, 1200, 'easeInOutQuad',function(){
				$(this).css({'display':'none'});
				$('aside#loader img').css({'opacity': 0});
			});
		}

		if(isTablet) {
			$('#restaurant-pc-col1-hour').css({'display':'none'});
			$('#row-l1-l2-c1-pc p span').css({'display':'none'});
		}
		var pil;
		var piw;
		var currentroom = 0;

		pil = $('#rooms-sp-l3 div ul li').eq(currentroom).position().left;
		piw = $('#rooms-sp-l3 div ul li').eq(currentroom).width();

		$('#rooms-sp-l3 div#rooms-sp-l3-scroll').stop(true,false).animate({left: (((_ww  - piw)/2) - pil) }, 800, 'easeInOutQuad');


		var roomuri = ['corner','superior','standard','king','triple','universal'];
		var mainRoomSwiperSP = new Swiper('#rooms-sp-l2 .swiper-container', {
			speed: 1200,
			loop: false,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
		});  
		mainRoomSwiperSP.on('transitionStart', function () {  
			currentroom = mainRoomSwiperSP.realIndex;
			$('#rooms-sp-l2 a').attr('href', '../rooms/index.html#'+roomuri[currentroom]);
			$('#rooms-sp-l3 div ul li').removeClass('active');
			$('#rooms-sp-l3 div ul li').eq(currentroom).addClass('active');
			pil = $('#rooms-sp-l3 div ul li').eq(currentroom).position().left;
			piw = $('#rooms-sp-l3 div ul li').eq(currentroom).width();

			$('#rooms-sp-l3 div#rooms-sp-l3-scroll').stop(true,false).animate({left: (((_ww  - piw)/2) - pil) }, 800, 'easeInOutQuad');
		});

		$('#rooms-sp-l3 div ul li').on({ 
			click:function($evt) { 
				mainRoomSwiperSP.slideTo($(this).index(),1200,false );
				currentroom = $(this).index();
				$('#rooms-sp-l2 a').attr('href', '../rooms/index.html#'+roomuri[currentroom]);
				$('#rooms-sp-l3 div ul li').removeClass('active');
				$('#rooms-sp-l3 div ul li').eq(currentroom).addClass('active');
				pil = $('#rooms-sp-l3 div ul li').eq(currentroom).position().left;
				piw = $('#rooms-sp-l3 div ul li').eq(currentroom).width();

				$('#rooms-sp-l3 div#rooms-sp-l3-scroll').stop(true,false).animate({left: (((_ww  - piw)/2) - pil) }, 800, 'easeInOutQuad');
				$evt.preventDefault();
			}
		});

		$('.scrolltop').on({ 
			click:function($evt) { 
				if(_ww > 767) {
					$('html, body').animate({scrollTop: $('section#about-rooms-pc').offset().top}, 800, 'easeInOutQuad');
				} else {
					$('html, body').animate({scrollTop: $('section#about-sp').offset().top}, 800, 'easeInOutQuad');
				}
				$evt.preventDefault();
			}
		});
		
		var mainRoomSwiperPC = new Swiper('#row-l3-c1-c2-pc-slider .swiper-container', {
			speed: 1200,
			loop: false,
			direction: 'vertical',
			slidesPerView: 1,
			spaceBetween: 0,
			autoplay: { delay: 5000 },
		});
		mainRoomSwiperPC.on('transitionStart', function () {  
			setSlideshowRoomPC(mainRoomSwiperPC.realIndex,'auto');
		});

		$('#row-l2-l3-c3-pc ul li').on({ 
			click:function($evt) { 
				setSlideshowRoomPC($(this).index(),'btn');
				$evt.preventDefault();
			}
		});

		function setSlideshowRoomPC($id,$from){
			if($from === 'btn'){
				mainRoomSwiperPC.slideTo($id,1200,false);
				$('#row-l2-l3-c3-pc ul li').removeClass('active');
				$('#row-l2-l3-c3-pc ul li').eq($id).addClass('active');	
				$('a#row-l3-c1-c2-pc-more').attr('href', '../rooms/index.html#'+$('#row-l2-l3-c3-pc ul li').eq($id).data('uri'));
			} else {
				$('#row-l2-l3-c3-pc ul li').removeClass('active');
				$('#row-l2-l3-c3-pc ul li').eq($id).addClass('active');	
				$('a#row-l3-c1-c2-pc-more').attr('href', '../rooms/index.html#'+$('#row-l2-l3-c3-pc ul li').eq($id).data('uri'));
			}
		}


	} 

	//======================================

	function _getRoomHash()
	{
		if(_ww > 767)
		{ 
			switch(document.location.hash)
			{
				case '#corner':
					$('html, body').delay(500).animate({scrollTop: $('#l3-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#superior':
					$('html, body').delay(500).animate({scrollTop: $('#l4-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#triple':
					$('html, body').delay(500).animate({scrollTop: $('#l5-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#king':
					$('html, body').delay(500).animate({scrollTop: $('#l6-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#standard':
					$('html, body').delay(500).animate({scrollTop: $('#l7-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#universal':
					$('html, body').delay(500).animate({scrollTop: $('#l8-c1').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#amenities':
					$('html, body').delay(500).animate({scrollTop: $('#l9-c1').offset().top}, 800, 'easeInOutQuad');
				break;
			}
		}
		else 
		{
			switch(document.location.hash)
			{
				case '#corner':
					$('html, body').animate({scrollTop: $('#l3').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#superior':
					$('html, body').animate({scrollTop: $('#l4').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#triple':
					$('html, body').animate({scrollTop: $('#l5').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#king':
					$('html, body').animate({scrollTop: $('#l6').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#standard':
					$('html, body').animate({scrollTop: $('#l7').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#universal':
					$('html, body').animate({scrollTop: $('#l8').offset().top}, 800, 'easeInOutQuad');
				break;
				case '#amenities':
					$('html, body').animate({scrollTop: $('#l9').offset().top}, 800, 'easeInOutQuad');
				break;
			}
		}
	}

	//=========================

	if($page === 'rooms')
	{
		$('#l2-c2-c3 ul li').on({ 
			click:function($evt) { 
				switch($(this).data('uri'))
				{
					case 'corner':
						$('html, body').animate({scrollTop: $('#l3-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'superior':
						$('html, body').animate({scrollTop: $('#l4-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'triple':
						$('html, body').animate({scrollTop: $('#l5-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'king':
						$('html, body').animate({scrollTop: $('#l6-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'standard':
						$('html, body').animate({scrollTop: $('#l7-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'universal':
						$('html, body').animate({scrollTop: $('#l8-c1').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'amenities':
						$('html, body').animate({scrollTop: $('#l9-c1').offset().top}, 800, 'easeInOutQuad');
					break;
				}
				$evt.preventDefault();
			}
		});

		$('#l2 ul li').on({ 
			click:function($evt) { 
				switch($(this).data('uri'))
				{
					case 'corner':
						$('html, body').animate({scrollTop: $('#l3').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'superior':
						$('html, body').animate({scrollTop: $('#l4').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'triple':
						$('html, body').animate({scrollTop: $('#l5').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'king':
						$('html, body').animate({scrollTop: $('#l6').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'standard':
						$('html, body').animate({scrollTop: $('#l7').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'universal':
						$('html, body').animate({scrollTop: $('#l8').offset().top}, 800, 'easeInOutQuad');
					break;
					case 'amenities':
						$('html, body').animate({scrollTop: $('#l9').offset().top}, 800, 'easeInOutQuad');
					break;
				}
				$evt.preventDefault();
			}
		});

		var cornerSwiperPC = new Swiper('#l3-c2-c3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	}
		}),
		superiorSwiperPC = new Swiper('#l4-c2-c3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	}
		}),
		tripleSwiperPC = new Swiper('#l5-c2-c3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			disableOnInteraction: true,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	}
		}),
		kingSwiperPC = new Swiper('#l6-c2-c3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	}
		}),
		standardSwiperPC = new Swiper('#l7-c2-c3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		}),
		universalSwiperPC = new Swiper('#l8-c2-c3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	}
		});  

		var cornerSwiperSP = new Swiper('#l3 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		}),
		superiorSwiperSP = new Swiper('#l4 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		}),
		tripleSwiperSP = new Swiper('#l5 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		}),
		kingSwiperSP = new Swiper('#l6 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		}),
		standardSwiperSP = new Swiper('#l7 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		}),
		universalSwiperSP = new Swiper('#l8 .swiper-container', {
			speed: 1200,
			loop: true,
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
		        el: '.swiper-pagination',
		        type: 'bullets',
		        clickable: true,
		 	},
		 	navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev',
		    }
		});
	}

	//=========================


	function __setPosition()
	{
		_ww = $window.width();
		_wh = $window.height();

		if($page === 'main')
		{
			if(_ww > 767)
			{ 
				$('#top-l').css({'height':'100vh'});	

				$('#row-l1-l2-c1-pc').css({'height': $('#row-l1-l2-c1-pc').width() * 2});
				$('#row-l1-c2-c3-pc').css({'height': $('#row-l1-l2-c1-pc').width() });
				$('#row-l2-c2-pc').css({'top': $('#row-l1-c2-c3-pc').position().top + $('#row-l1-c2-c3-pc').height(), 'height': $('#row-l2-c2-pc').width()});
				$('#row-l2-l3-c3-pc').css({'top': $('#row-l1-c2-c3-pc').position().top + $('#row-l1-c2-c3-pc').height(), 'height': ($('#row-l2-l3-c3-pc').width() * 2)});
				$('#row-l3-c1-c2-pc').css({'top': $('#row-l1-l2-c1-pc').position().top + $('#row-l1-l2-c1-pc').height(), 'height': ($('#row-l3-c1-c2-pc').width() / 2) });
				$('#about-rooms-pc').css({'height': ($('#row-l2-l3-c3-pc').position().top + $('#row-l2-l3-c3-pc').height())});
			
				$('#restaurant-pc-col1').css({'height': $('#restaurant-pc-col1').width()});
				$('#restaurant-pc-col2').css({'height': $('#restaurant-pc-col1').width()});
				$('#restaurant-pc').css({'height': $('#restaurant-pc-col1').height()});

				$('#graphic-pc-col1').css({'height': $('#graphic-pc-col3').width()});
				$('#graphic-pc-col2').css({'height': $('#graphic-pc-col3').width()});
				$('#graphic-pc-col3').css({'height': $('#graphic-pc-col3').width()});
				$('#graphic-pc').css({'height': $('#graphic-pc-col3').height()});

				$('#lobby-pc-col1').css({'height': $('#lobby-pc-col1').width()});
				$('#lobby-pc-col2').css({'height': $('#lobby-pc-col1').width()});
				$('#lobby-pc').css({'height': $('#lobby-pc-col1').height()});

				$('#gallery-pc-col1').css({'height': $('#gallery-pc-col1').width()});
				$('#gallery-pc-col2').css({'height': $('#gallery-pc-col1').width()});
				$('#gallery-pc-col3').css({'height': $('#gallery-pc-col1').width()});
				$('#gallery-pc').css({'height': $('#gallery-pc-col1').height()});

				$('#connect-pc-col1').css({'height': $('#connect-pc-col1').width()});
				$('#connect-pc-col2').css({'height': $('#connect-pc-col1').width()});
				$('#connect-pc').css({'height': $('#connect-pc-col1').height()});

				$('#place-pc, #place-pc-col2, #place-pc-col3').css({'height':'auto'});
				$('#place-pc-col2').css({'height': $('#place-pc-col1').height() + 60});
				$('#place-pc-col3').css({'height': $('#place-pc-col1').height()});
				$('#place-pc').css({'height': $('#place-pc-col1').height() });
				
				$('#contact-pc-col1').css({'height': ($('#contact-pc-col1').width())});
				$('#contact-pc-col2').css({'height': ($('#contact-pc-col1').width())});
				$('#contact-pc').css({'height': $('#contact-pc-col1').height()});

				$('footer').css({'position':'absolute','top': ($('#contact-pc-col1').height() + $('#contact-pc').position().top)});

				mainRoomSwiperPC.update();
			} 
			else 
			{
				$('#top-l').css({'height': $('section#top').height() - $('#top-r').height() - 120});

				$('#about-sp-l1').css({'height': ($('#about-sp-l1').width() / 2)});
				$('#about-sp-l2').css({'height': ($('#about-sp-l2').width() / 2)});
				$('#rooms-sp-l2').css({'height': ($('#rooms-sp-l2').width())});
				$('#graphic-sp-l2').css({'height': ($('#graphic-sp-l2').width() / 2)});
				$('#gallery-sp-l2').css({'height': $('#gallery-sp-l2').width()});
				$('footer').css({'top':'auto','position':'relative'});

				pil = $('#rooms-sp-l3 div ul li').eq(currentroom).position().left;
				piw = $('#rooms-sp-l3 div ul li').eq(currentroom).width();
				$('#rooms-sp-l3 div#rooms-sp-l3-scroll').css({left: (((_ww  - piw)/2) - pil) });
			}
			
		} 

		//========================

		if($page === 'about')
		{
			if(_ww > 767)
			{
				$('#l1-c2-c3').css({'height': $('#l1-c1').height()});
				$('#l2-c1, #l2-c2, #l2-c3').css({'top': $('#l1-c1').height()});
				$('#l2-c2').css({'height': $('#l2-c1').height()});
				$('#l2-c3').css({'height': $('#l2-c1').height()});
				
				if($('#l2-c1').height() + $('#l2-c1').position().top + 130 > _wh){
					$('footer').css({'position':'absolute','top': ($('#l2-c1').height() + $('#l2-c1').position().top)});
				} else {
					$('footer').css({'position':'absolute','top':'auto','bottom':0});
				}
			}
			else
			{
				$('footer').css({'position':'relative','top': 'auto','bottom': 'auto'});
			}
		}

		//========================

		if($page === 'rooms')
		{
			if(_ww > 767)
			{
				$('#l1-c2-c3').css({'height': $('#l1-c1').height()});
				$('#l2-c1, #l2-c2-c3').css({'top': $('#l1-c1').height()});
				$('#l2-c1').css({'height': $('#l2-c2-c3').height()});
				$('#l3-c1').css({'top': $('#l2-c1').height() + $('#l2-c1').position().top + 30 });
				$('#l3-c2-c3').css({'top': $('#l3-c1').position().top, 'height': $('#l3-c1').height() });
				$('#l4-c1').css({'top': $('#l3-c1').height() + $('#l3-c1').position().top });
				$('#l4-c2-c3').css({'top': $('#l4-c1').position().top, 'height': $('#l4-c1').height() });
				$('#l5-c1').css({'top': $('#l4-c1').height() + $('#l4-c1').position().top });
				$('#l5-c2-c3').css({'top': $('#l5-c1').position().top, 'height': $('#l5-c1').height() });
				$('#l6-c1').css({'top': $('#l5-c1').height() + $('#l5-c1').position().top });
				$('#l6-c2-c3').css({'top': $('#l6-c1').position().top, 'height': $('#l6-c1').height() });
				$('#l7-c1').css({'top': $('#l6-c1').height() + $('#l6-c1').position().top });
				$('#l7-c2-c3').css({'top': $('#l7-c1').position().top, 'height': $('#l7-c1').height() });
				$('#l8-c1').css({'top': $('#l7-c1').height() + $('#l7-c1').position().top });
				$('#l8-c2-c3').css({'top': $('#l8-c1').position().top, 'height': $('#l8-c1').height() });
				
				if(_ww <= 1200){
					$('#l9-c1').css({'top': $('#l8-c1').height() + $('#l8-c1').position().top, 'height': '560px' });
					$('#l9-c2-c3').css({'top': $('#l9-c1').position().top, 'height': '560px' });
				} else {
					$('#l9-c1').css({'top': $('#l8-c1').height() + $('#l8-c1').position().top, 'height': '320px' });
					$('#l9-c2-c3').css({'top': $('#l9-c1').position().top, 'height': '320px' });
				}
				
				$('footer').css({'position':'absolute','top': ($('#l9-c1').height() + $('#l9-c1').position().top - 30 )});
			}
			else
			{
				$('footer').css({'position':'relative','top': 'auto'});
			}
		}

		//========================

		if($page === 'restaurant')
		{
			if(_ww > 767)
			{
				$('#l1-l2-c2-c3').css({'height': $('#l1-l2-c2-c3-1').width()});
				if($('#l1-c1').height() > $('#l1-l2-c2-c3').height()) {
					$('footer').css({'position':'absolute','top': ($('#l1-c1').height() + $('#l1-c1').position().top )});
					$('#l1-l2-c2-c3').css({'height': $('#l1-c1').height()});
				} else {
					$('#l1-l2-c2-c3').css({'height': $('#l1-l2-c2-c3-1').width()});
					$('footer').css({'position':'absolute','top': ($('#l1-l2-c2-c3').height() + $('#l1-l2-c2-c3').position().top )});
				}
			}
			else
			{
				$('footer').css({'position':'relative','top': 'auto','bottom': 'auto'});
			}
		}

		//========================

		if($page === 'graphic')
		{
			if(_ww > 767)
			{
				
				$('#l1-c2-c3 #l1-c2-c3-2').css({'height': $('#l1-c2-c3-2-l').width() });
				$('#l1-c2-c3 #l1-c2-c3-1').css({'height':  $('#l1-c2-c3-2-l').width() });

				$('#l1-c2-c3-2-l').css({'height': $('#l1-c2-c3-2-l').width()});
				$('#l1-c2-c3-2-r').css({'height': $('#l1-c2-c3-2-l').width()});
				$('#l1-c2-c3').css({'height': $('#l1-c2-c3-2-l').height() * 2});

				$('#l2-c2-c3 #l2-c2-c3-2').css({'height': $('#l1-c2-c3-2-l').width() });
				$('#l2-c2-c3-2-l').css({'height': $('#l1-c2-c3-2-l').width()});
				$('#l2-c2-c3-2-r').css({'height': $('#l1-c2-c3-2-l').width()});
				$('#l2-c2-c3').css({'top': ($('#l1-c2-c3').height() + $('#l1-c2-c3').position().top) });


				$('#l1-c1').css({'height':  ($('#l2-c2-c3').height() + $('#l2-c2-c3').position().top)});


				if($('#l1-c1').height() > _wh) {
					$('footer').css({'position':'absolute','top': ($('#l1-c1').height() + $('#l1-c1').position().top)}); 
				} else {
					$('footer').css({'position':'absolute','top':'auto', 'bottom':'0'}); 
				}

				
			}
			else
			{
				$('footer').css({'position':'relative','top': 'auto','bottom': 'auto'});
			}
		}

		//========================

		if($page === 'gallery')
		{
			if(_ww > 767)
			{
				$('#l1-c2-c3').css({'height': $('#l1-c1').height()});
				$('#l2-c1-c2').css({'top': $('#l1-c1').height(), 'height': ($('#l2-c1-c2').width() / 2) });
				$('#l2-l3-c3').css({'top': $('#l1-c1').height(), 'height': ($('#l2-c1-c2').height() * 2) });
				$('#l3-c1').css({'top': ($('#l2-c1-c2').height() + $('#l2-c1-c2').position().top), 'height': $('#l3-c1').width() });
				$('#l3-c2').css({'top': $('#l3-c1').position().top, 'height': $('#l3-c1').width() });
				$('#l4-l5-c1').css({'top': ($('#l3-c1').height() + $('#l3-c1').position().top), 'height': ($('#l4-l5-c1').width() * 2)});
				$('#l4-c1-c2').css({'top': $('#l4-l5-c1').position().top, 'height': $('#l4-l5-c1').width() });
				$('#l5-c1-c2').css({'top': $('#l4-l5-c1').position().top + $('#l4-l5-c1').width(), 'height': $('#l4-l5-c1').width() });
				$('#l6-c1-c2').css({'top': ($('#l4-l5-c1').height() + $('#l4-l5-c1').position().top), 'height': ($('#l6-c1-c2').width() / 2)});
				$('#l6-c3').css({'top': $('#l6-c1-c2').position().top, 'height': ($('#l6-c3').width())});
				$('#l7-c1-c2-c3').css({'top': ($('#l6-c3').height() + $('#l6-c3').position().top), 'height': ($('#l6-c3').width())});
				$('#l8-c1').css({'top': ($('#l7-c1-c2-c3').height() + $('#l7-c1-c2-c3').position().top), 'height': ($('#l6-c3').width())});
				$('#l8-c2-c3').css({'top': $('#l8-c1').position().top, 'height': ($('#l8-c1').width())});
				$('#l9-c1-c2').css({'top': ($('#l8-c1').position().top + $('#l8-c1').height()), 'height': ($('#l9-c1-c2').width() )});
				$('#l9-c3').css({'top': $('#l9-c1-c2').position().top, 'height': $('#l9-c1-c2').height()});
				$('#l10').css({'top': ($('#l9-c3').position().top + $('#l9-c3').height()), 'height': ($('#l8-c1').width() * 3)});
				$('footer').css({'position':'absolute','top': ($('#l10').height() + $('#l10').position().top)});
			}
			else
			{
				$('footer').css({'position':'relative','top': 'auto','bottom': 'auto'});
			}
		}

		//========================

		if($page === 'privacy')
		{
			if(_ww > 767)
			{
				$('footer').css({'position':'absolute','top': ($('#l1-c2-c3').height() + $('#l1-c2-c3').position().top)});
			}
			else
			{
				$('footer').css({'position':'relative','top':'auto','bottom':'auto','margin-top':'-60px' });
			}
		}

	}

	$window.resize(function() { __setPosition(); });	
	__setPosition();

	if($page === 'rooms' && document.location.hash != ''){ _getRoomHash(); }


	function __setScroll()
	{
		_ws = $(window).scrollTop();
		if(navOp) { _setNav(); }

		if($page === 'main')
		{
			if(_ww > 767)
			{
				if((_ws + 65) < $('#gallery-pc').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 65) > $('#gallery-pc').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }
				if((_ws + 65) > $('#connect-pc').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 65) > $('#contact-pc').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }

				if((_ws + 65) < $('#about-rooms-pc').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 65) > $('#about-rooms-pc').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 65) > $('#row-l3-c1-c2-pc').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 65) > $('#restaurant-pc').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 65) > $('#graphic-pc').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 65) > $('#place-pc').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 65) > $('#contact-pc').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }

				if($('#lobby-pc').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
				if($('#gallery-pc').isOnScreen() && !$('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').addClass('black'); }
				if($('#connect-pc').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
				if($('#contact-pc').isOnScreen() && !$('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').addClass('black'); }
				if($('footer').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }

				if($('#top').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#about-rooms-pc').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#row-l3-c1-c2-pc-slider').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#restaurant-pc').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#graphic-pc').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#connect-pc').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#place-pc').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#contact-pc').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
			}
			else 
			{
				if((_ws + 30) < $('#about-sp-l3').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#about-sp-l3').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }
				if((_ws + 30) > $('#rooms-sp').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#restaurant-sp').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }
				if((_ws + 30) > $('#graphic-sp').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#gallery-sp').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }
				if((_ws + 30) > $('#gallery-sp-l2').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#gallery-sp-l3').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }
				if((_ws + 30) > $('#connect-sp').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#book-sp').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }
				if((_ws + 30) > $('#map-sp').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#contact-sp').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }

				if((_ws + 30) < $('#about-sp-l3').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#about-sp-l3').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 30) > $('#rooms-sp').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#restaurant-sp').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 30) > $('#graphic-sp').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#gallery-sp').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 30) > $('#gallery-sp-l2').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#gallery-sp-l3').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 30) > $('#connect-sp').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#book-sp').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 30) > $('#map-sp').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#contact-sp').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }

				if($('#top').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#about-sp-l3').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#rooms-sp').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#restaurant-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#graphic-sp').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#gallery-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#connect-sp').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#book-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#map-sp').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#contact-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('footer').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }

				
				if($('#top').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
				if($('#about-sp-l3').isOnScreen() && !$('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').addClass('black'); }
				if($('#rooms-sp').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
				if($('#restaurant-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').addClass('black'); }
				if($('#graphic-sp').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
				if($('#gallery-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').addClass('black'); }
				if($('#connect-sp').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
				if($('#book-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').addClass('black'); }
				if($('#map-sp').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
				if($('#contact-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').addClass('black'); }
				if($('footer').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }

			}
		}

		if($page === 'about')
		{
			if(_ww > 767)
			{
				$('#corner-top-right').addClass('black');
				$('#corner-top-left').addClass('black'); 
			}
			else
			{
				if((_ws + 30) < $('#l2').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#l2').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }
				if((_ws + 30) > $('#l3').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#l4').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }

				if((_ws + 30) < $('#l2').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#l2').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 30) > $('#l3').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#l4').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
			}
		}

		if($page === 'rooms')
		{
			if(_ww > 767)
			{
				if((_ws + 65) < $('#l3-c1').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 65) > $('#l3-c1').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 65) > $('#l4-c1').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 65) > $('#l5-c1').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 65) > $('#l6-c1').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 65) > $('#l7-c1').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 65) > $('#l8-c1').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }

				if($('#l2-c1').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#l3-c1').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#l4-c1').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#l5-c1').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#l6-c1').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#l7-c1').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#l8-c1').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#l9-c1').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
			}
			else
			{
				if((_ws + 30) < $('#l3 .block-room-sp').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#l3 .block-room-sp').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }
				if((_ws + 30) > $('#l4').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#l5 .block-room-sp').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }
				if((_ws + 30) > $('#l6').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }
				if((_ws + 30) > $('#l7 .block-room-sp').offset().top && !$('#corner-top-right').hasClass('black')) { $('#corner-top-right').addClass('black'); }
				if((_ws + 30) > $('#l8').offset().top && $('#corner-top-right').hasClass('black')) { $('#corner-top-right').removeClass('black'); }

				if((_ws + 30) < $('#l3 .block-room-sp').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#l3 .block-room-sp').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 30) > $('#l4').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#l5 .block-room-sp').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 30) > $('#l6').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }
				if((_ws + 30) > $('#l7 .block-room-sp').offset().top && !$('#corner-top-left').hasClass('black')) { $('#corner-top-left').addClass('black'); }
				if((_ws + 30) > $('#l8').offset().top && $('#corner-top-left').hasClass('black')) { $('#corner-top-left').removeClass('black'); }

				if($('#l2').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#l3 .block-room-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#l4').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#l5 .block-room-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#l6').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#l7 .block-room-sp').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }
				if($('#l8').isOnScreen() && $('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').removeClass('black'); }
				if($('#l9').isOnScreen() && !$('#corner-bottom-left').hasClass('black')) { $('#corner-bottom-left').addClass('black'); }

				if($('#l2').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
				if($('#l3 .block-room-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').addClass('black'); }
				if($('#l4').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
				if($('#l5 .block-room-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').addClass('black'); }
				if($('#l6').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
				if($('#l7 .block-room-sp').isOnScreen() && !$('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').addClass('black'); }
				if($('#l8').isOnScreen() && $('#corner-bottom-right').hasClass('black')) { $('#corner-bottom-right').removeClass('black'); }
			}
		}
	}
	$(window).on('resize scroll', function() { __setScroll(); });
	__setScroll();


			

	
});

